import { useContext } from 'react';
import { Button, DropDown, Flex, ModalContext } from 'dash-ui';
import {
  DEFAULT_MEDIA_FOLDERS_LIST,
  MediaTypesEnum,
  SystemMediaFoldersTypesEnum,
} from 'dash-common';
import { useTranslation } from 'react-i18next';

import { downloadMedia } from 'common/helpers/downloadMedia';
import { Media } from 'gql/generated.graphql';
import {
  StyledButtonContainer,
  ToggleContainer,
  ButtonWrapper,
} from 'containers/properties/PropertyMedia/components/MediaFilesView/components/MediaFilesList/components/MediaFileItem/MediaFileItem.styles';

const ActionButtons = ({
  media,
  deletable,
}: {
  media: Media;
  deletable?: boolean;
}) => {
  const { t } = useTranslation();
  const { toggleModal, setPayload } = useContext(ModalContext);
  const isFolder = media.type === MediaTypesEnum.FOLDER;
  const isDefaultFolder = DEFAULT_MEDIA_FOLDERS_LIST.includes(
    media.systemFolderType as SystemMediaFoldersTypesEnum
  );

  return (
    <StyledButtonContainer justifyContent="flex-end">
      {!isFolder && (
        <>
          <ToggleContainer>
            <DropDown
              Anchor={() => (
                <ButtonWrapper>
                  <Button icon="dots" square variation="outline" />
                </ButtonWrapper>
              )}
              items={[
                {
                  key: 'edit',
                  children: t('common:labels.rename'),
                  contentCentered: false,
                  w: 150,
                  onClick: () => {
                    toggleModal(true, 'EditMediaFileModal');
                    setPayload(media.files[0]);
                  },
                },
                {
                  key: 'move',
                  children: t('pages:propertyPage.moveToFolder'),
                  contentCentered: false,
                  w: 150,
                  onClick: () => {
                    toggleModal(true, 'MoveFileToFolderModal');
                    setPayload({
                      mediaIds: [media._id],
                      propertyId: media.propertyId,
                    });
                  },
                },
              ]}
            />
          </ToggleContainer>
          <ButtonWrapper>
            <Button
              mx={2}
              onClick={(e: { stopPropagation: Function }) => {
                e.stopPropagation();
                downloadMedia([media._id]);
              }}
              square
              variation="outline"
              icon="download"
            />
          </ButtonWrapper>
        </>
      )}
      {deletable && (
        <Flex>
          {isFolder && (
            <Button
              square
              icon="edit"
              onClick={(event) => {
                event.stopPropagation();
                toggleModal(true, 'SetFolderNameModal');
                setPayload({ media });
              }}
            />
          )}
          {!isDefaultFolder && (
            <Button
              ml={isFolder ? 2 : 0}
              onClick={(e: { stopPropagation: Function }) => {
                e.stopPropagation();
                toggleModal(
                  true,
                  isFolder ? 'RemoveFolderModal' : 'RemoveMediaFileModal'
                );
                setPayload({ media });
              }}
              square
              icon="trash"
            />
          )}
        </Flex>
      )}
    </StyledButtonContainer>
  );
};

export default ActionButtons;
